import { getGraphicForCaption } from '../config/captionGraphicMap';

/**
 * Pure payload builder for the clock graphic's APPLY_DATA frame.
 *
 * Extracted from useBrokerService.sendApplyDataState so unit tests can
 * assert payload shape without standing up the hook. The hook now wraps
 * this builder + updateRenderer; nothing else changes about how callers
 * use it.
 *
 * The outer graphic key is resolved by caption name (defaults to "Main")
 * so this builder follows the same caption→graphic mapping as the rest
 * of the broker calls — see captionGraphicMap.js.
 */
export const buildApplyDataPayload = ({
  scores,
  homeTeam,
  awayTeam,
  redCardTabs,
  // Defaults to false: every caption shares the gfx_PermScore layer, so a Cards
  // block of empty strings blanks iWhichTeam and takes the whole graphic into a
  // blank state on air. The event-service builders dropped it for the same
  // reason (OPUS-1302). Pass true only if a caller genuinely needs the card
  // fields reset and has confirmed the template tolerates it.
  clearCards = false,
  graphic,
} = {}) => {
  const homeScore = String(Number(scores?.home ?? 0));
  const awayScore = String(Number(scores?.away ?? 0));

  const homeReds = redCardTabs && Number.isFinite(redCardTabs.home)
    ? Number(redCardTabs.home)
    : "";
  const awayReds = redCardTabs && Number.isFinite(redCardTabs.away)
    ? Number(redCardTabs.away)
    : "";

  const graphicKey = graphic || getGraphicForCaption("Main");

  return {
    [graphicKey]: {
      Main: {
        iClockNumber: 0,
        iClockRedTime: 0,
        bMobileOptimisedActive: false,
        Team1: {
          strSetStyle: "",
          strTeamTricode: homeTeam?.team_tricode || "",
          strTeamName: homeTeam?.team_name || "",
          iRedCardTabs: homeReds,
          Score: { strScore: homeScore },
          Score_UD: { strScore: homeScore },
        },
        Team2: {
          strSetStyle: "",
          strTeamTricode: awayTeam?.team_tricode || "",
          strTeamName: awayTeam?.team_name || "",
          iRedCardTabs: awayReds,
          Score: { strScore: awayScore },
          Score_UD: { strScore: awayScore },
        },
      },
      ...(clearCards
        ? {
            Cards: {
              iCardType: "",
              iWhichTeam: "",
              strSecondName: "",
              strShirtNumber: "",
              strTitle: "",
            },
          }
        : {}),
    },
  };
};
